// v1.2.0 · Lo que firmas con nosotros: compromisos del contrato tipo, con la cláusula que los respalda
// v1.3.0 · Presentado como una hoja de contrato: cláusulas en el margen y firmas electrónicas al pie
import React from 'react';
import { guarantees } from '../../data/site';

export default function SiteGuarantees() {
  return (
    <section id="garantias" data-scan className="seam scroll-mt-24 py-20 lg:py-28">
      <div className="mx-auto max-w-[1240px] px-5 sm:px-8">
        <div className="grid gap-10 lg:grid-cols-[0.75fr_1.5fr] lg:gap-16">
          <div data-reveal className="lg:sticky lg:top-28 lg:self-start">
            <h2 className="display text-[2.8rem] sm:text-[3.6rem]">Lo que firmas con nosotros</h2>
            <p className="mt-5 text-[1.0625rem] leading-[1.65] text-[var(--ink-2)]">
              Cada compromiso está escrito en nuestro contrato de desarrollo, con su cláusula. Lo firmas de forma
              electrónica antes de empezar.
            </p>
          </div>

          <article data-reveal style={{ '--rd': '140ms' }} className="contract rounded-[4px] border border-[var(--line)] bg-[var(--sheet)] px-5 py-8 sm:px-10 sm:py-12" aria-label="Extracto del contrato">
            <p className="text-[13px] font-semibold text-[var(--ink-2)]">Contrato de desarrollo de software a medida</p>
            <p className="text-[13px] text-[var(--ink-2)]">Extracto de compromisos de Analytica con el cliente</p>
            <ol className="mt-8">
              {guarantees.map((g) => (
                <li key={g.title} className="grid gap-1 border-t border-[var(--line)] py-6 sm:grid-cols-[150px_1fr] sm:gap-6">
                  <span className="num pt-1 text-[13px] font-semibold text-[var(--steel)]">{g.clause}</span>
                  <div>
                    <h3 className="display-2 text-[1.45rem]">{g.title}</h3>
                    <p className="mt-2 text-[15px] leading-[1.65] text-[var(--ink-2)]">{g.text}</p>
                  </div>
                </li>
              ))}
            </ol>
            <div className="mt-6 grid gap-8 border-t border-[var(--line)] pt-10 sm:grid-cols-2">
              {['Firma electrónica del cliente', 'Firma electrónica de Analytica'].map((who) => (
                <div key={who}>
                  <div className="h-10 border-b border-dashed border-[#9FB2B5]" aria-hidden />
                  <p className="mt-2 text-[13px] text-[var(--ink-2)]">{who}</p>
                </div>
              ))}
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
